import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const initiateRazorpayPayment = async (orderData, onSuccess, onError) => {
  try {
    // Load Razorpay script
    const scriptLoaded = await loadRazorpayScript();
    
    if (!scriptLoaded) {
      alert('Failed to load payment gateway. Please try again.');
      return;
    }

    // Create order on backend
    const response = await axios.post(`${API}/razorpay/create-order`, orderData);
    const { razorpay_order_id, amount, currency, order_id, order_number, key_id } = response.data;

    // Razorpay options
    const options = {
      key: key_id,
      amount: amount,
      currency: currency,
      name: 'Behat House Atelier',
      description: `Order #${order_number}`,
      order_id: razorpay_order_id,
      handler: async function (response) {
        try {
          // Verify payment on backend
          const verifyResponse = await axios.post(`${API}/razorpay/verify-payment`, {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            order_id: order_id
          });

          if (verifyResponse.data.status === 'success') {
            onSuccess(order_id, order_number);
          } else {
            onError('Payment verification failed');
          }
        } catch (error) {
          console.error('Payment verification error:', error);
          onError('Payment verification failed');
        }
      },
      prefill: {
        name: orderData.shipping_address.name,
        email: orderData.shipping_address.email,
        contact: orderData.shipping_address.phone
      },
      theme: {
        color: '#8B7355'
      },
      modal: {
        ondismiss: function() {
          onError('Payment cancelled');
        }
      }
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();
  } catch (error) {
    console.error('Payment initiation error:', error);
    onError('Failed to initiate payment');
  }
};
